import {
  EnvironmentProviders,
  Provider,
  importProvidersFrom,
  inject,
  provideEnvironmentInitializer,
} from '@angular/core';
import { I18nPluralPipe } from '@angular/common';
import { BdUserCookieModule } from '@bindoc-projects/user-lib/ui';
import { BdPageTitleService } from '@bindoc-projects/util-lib/data';

/**
 * Root providers for the headless/no-user-auth app profile (formerly
 * `BdAppStarterNoAuthModule`).
 */
export function provideAppStarterNoAuth(
  securityProviders: Array<Provider | EnvironmentProviders>,
): Array<Provider | EnvironmentProviders> {
  return [
    ...securityProviders,
    importProvidersFrom(BdUserCookieModule.forRoot()),
    // See `provideAppStarter()` for why this is not redundant with
    // `providedIn: 'root'`.
    I18nPluralPipe,
    provideEnvironmentInitializer(() => {
      inject(BdPageTitleService).init();
    }),
  ];
}
